import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import { Ability } from "@casl/ability";

export const defaultAbility = new Ability();

export const AbilityContext = createContext(defaultAbility);
export const Can = createContextualCan(AbilityContext.Consumer);
